import React from 'react';
import { Review, TagCoupon } from '@magalu/stereo-ui/molecules';
import { bool, number, shape, string } from 'prop-types';
import { Button, OfferTimer, OfferTimerContainer, ShippingDescription, ShippingTag, TagCouponContainer } from './QuickClickCard.styles';
import { getHighestPriorityTag } from './QuickClickCard.utils';
var QuickClickCardFooter = function QuickClickCardFooter(_ref) {
  var button = _ref.button,
    hasActionButton = _ref.hasActionButton,
    shippingTag = _ref.shippingTag,
    rating = _ref.rating,
    restrictions = _ref.restrictions,
    tagCoupon = _ref.tagCoupon;
  var highestPriorityShippingTag = getHighestPriorityTag(shippingTag);
  if (button && hasActionButton) {
    return React.createElement(Button, {
      "data-testid": "quickclickcard-button",
      full: true,
      tabIndex: "-1",
      "aria-label": button.label
    }, button.label);
  }
  if (restrictions && restrictions.timer_end_date && restrictions.timer_start_date) {
    return React.createElement(OfferTimerContainer, {
      "data-testid": "quickclickcard-offertimer-container"
    }, React.createElement(OfferTimer, {
      restrictions: {
        timer_end_date: restrictions.timer_end_date,
        timer_start_date: restrictions.timer_start_date
      },
      text: "Termina em"
    }));
  }
  if (tagCoupon) {
    return React.createElement(TagCouponContainer, null, React.createElement(TagCoupon, {
      showIcon: false,
      mt: 1,
      tags: tagCoupon
    }));
  }
  if (highestPriorityShippingTag) {
    return React.createElement(ShippingTag, null, React.createElement(ShippingDescription, {
      "data-testid": highestPriorityShippingTag.testId
    }, highestPriorityShippingTag.content));
  }
  if (rating && !!(rating == null ? void 0 : rating.score)) {
    return React.createElement(Review, {
      count: rating.count,
      score: rating.score,
      width: "12px",
      height: "12px"
    });
  }
  return null;
};
process.env.NODE_ENV !== "production" ? QuickClickCardFooter.propTypes = {
  button: shape({
    action: string.isRequired,
    label: string.isRequired
  }),
  hasActionButton: bool,
  rating: shape({
    count: number,
    score: number
  }),
  restrictions: shape({}),
  shippingTag: shape({}),
  tagCoupon: shape({})
} : void 0;
QuickClickCardFooter.defaultProps = {
  button: null,
  hasActionButton: false,
  rating: null,
  restrictions: null,
  shippingTag: {
    complement: null,
    cost: null,
    time: null
  },
  tagCoupon: null
};
export default QuickClickCardFooter;